import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-listing',
  templateUrl: './order-listing.page.html',
  styleUrls: ['./order-listing.page.scss'],
})
export class OrderListingPage implements OnInit {
  message: string = '';
  isOrders: boolean = true;
  orders = [];
  is_dark_mode = false;
  
  constructor(private orderService:OrderService,private router:Router) {
    
   }

  ionViewWillEnter(){
    let isDark = localStorage.getItem('dark_mode');
    if(isDark == 'true'){
      this.is_dark_mode = true;
    }else{
      this.is_dark_mode = false;
    }
    this.getOrders();
  }

  ngOnInit() {   
  }

  getOrders(){ 
    this.orderService.getOrders().subscribe( 
      response => {
        this.message = '';         
        this.isOrders = true;
        function sortByDate(a, b) {
          if (a.date < b.date) {
              return 1;
          }
          if (a.date > b.date) {
              return -1;
          }
          return 0;
      }      
      this.orders = response.data.sort(sortByDate);
      },
      error => {
        this.isOrders = false;
        this.message = error.error.message;
      }
    );      
  }

  orderDetail(type, nr){
    if(type == 'cl'){
      this.router.navigate(['lenses-order-detail'], { state: { nr: nr } });
    }else if(type == 'br'){
      this.router.navigate(['glasses-new-order-detail'], { state: { nr: nr } });
    }else if(type == 'repair'){
      this.router.navigate(['glasses-repair-order-detail'], { state: { nr: nr } });
    }
    
  }

  backPage(){
    this.router.navigate(['dashboard']);
  }

  backHome(){
    this.router.navigate(['home']);
  }

}
